export default __webpack_public_path__ + "static/media/nobooks.163b94fc.png";